import * as React from 'react';

import classnames from 'classnames';

import type {DeltaMood, DeltaDirection} from 'nutshell-core/types';

import styles from './delta-arrow.module.css';

type DeltaArrowProps = {
    deltaMood: DeltaMood;
    deltaDirection: DeltaDirection;
    size: 'tiny' | 'small' | 'large';
};

/**
 * Show an arrow indicating movement up or down (or no movement), and whether that’s good or bad.
 */
export class DeltaArrow extends React.Component<DeltaArrowProps> {
    static defaultProps = {
        size: 'large',
    };

    render() {
        let arrowFile;
        switch (this.props.deltaMood) {
            case 'positive':
                arrowFile = '/include/images/dashboard/arrow-green_2x.png';
                break;
            case 'negative':
                arrowFile = '/include/images/dashboard/arrow-red_2x.png';
                break;
            case 'neutral': // Passthrough
            default:
                arrowFile = '/include/images/dashboard/arrow-grey_2x.png';
        }

        const styleNames = classnames(null, {
            [styles['arrow-up']]: this.props.deltaDirection === 'up',
            [styles['arrow-down']]: this.props.deltaDirection === 'down',
            [styles['arrow-unchanged']]: this.props.deltaDirection === 'neutral',
            [styles['arrow-large']]: this.props.size === 'large',
            [styles['arrow-small']]: this.props.size === 'small',
            [styles['arrow-tiny']]: this.props.size === 'tiny',
        });

        return this.props.deltaDirection === 'neutral' ? (
            <div className={styleNames} />
        ) : (
            <img src={arrowFile} className={styleNames} />
        );
    }
}
